import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AppComponent} from "./app.component";

declare var Drupal: any;
let basePath = 'soil-water/'; //(typeof Drupal !== 'undefined') ? '/' + Drupal.settings.pathAlias : '';

const routes: Routes = [
];

routes.push(  { path: basePath, component: AppComponent });

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
